'use client';

import { useContext } from 'react';

import { Turnstile, TurnstileProps } from '@marsidev/react-turnstile';

import { Captcha } from './captcha-provider';

interface CaptchaTokenSetterProps {
  siteKey: string | undefined;
  options?: TurnstileProps;
  /** The widget errored, timed out, or is unsupported: no token is coming. */
  onError?: () => void;
}

export function CaptchaTokenSetter(props: CaptchaTokenSetterProps) {
  const { setToken, setInstance } = useContext(Captcha);

  if (!props.siteKey) {
    return null;
  }

  const options = props.options ?? {
    options: {
      size: 'normal',
      appearance: 'interaction-only',
      theme: 'light',
    },
  };

  return (
    <div className="flex justify-center">
      <Turnstile
        ref={(instance) => {
          if (instance) {
            setInstance(instance);
          }
        }}
        siteKey={props.siteKey}
        onSuccess={setToken}
        onExpire={() => {
          // Clear the stale token from React state. The widget auto-refreshes
          // (refreshExpired defaults to "auto") and will call onSuccess with
          // a fresh token.
          setToken('');
        }}
        onError={props.onError}
        onTimeout={props.onError}
        onUnsupported={props.onError}
        {...options}
      />
    </div>
  );
}
